/* eslint-disable global-require, quote-props */
window.jsmodule = {
  ...window.jsmodule,
  '@fluentui/react': require('@fluentui/react'),
  '@/shiny.fluent': require('./inputs'),
};
